"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ErrorCode;
(function (ErrorCode) {
    ErrorCode["Validation"] = "Validation";
    ErrorCode["AuthUnauthorized"] = "AuthUnauthorized";
    ErrorCode["AuthExpiredOrRevokedToken"] = "AuthExpiredOrRevokedToken";
    ErrorCode["AuthOverlayDeleted"] = "AuthOverlayDeleted";
    ErrorCode["AuthUnauthenticated"] = "AuthUnauthenticated";
    ErrorCode["AuthInvalidDetails"] = "AuthInvalidDetails";
    ErrorCode["AuthEmailNotVerified"] = "AuthEmailNotVerified";
    ErrorCode["AuthInvalidToken"] = "AuthInvalidToken";
    ErrorCode["MissingOrgHeader"] = "MissingOrgHeader";
    ErrorCode["AuthInvalidAuthorizationHeader"] = "AuthInvalidAuthorizationHeader";
    ErrorCode["AuthMissingOrgId"] = "AuthMissingOrgId";
    ErrorCode["AuthNoAccess"] = "AuthNoAccess";
    ErrorCode["AuthPasswordMismatch"] = "AuthPasswordMismatch";
    ErrorCode["AuthIncorrectPassword"] = "AuthIncorrectPassword";
    ErrorCode["RegisterAlreadyVerified"] = "RegisterAlreadyVerified";
    ErrorCode["RegisterInvalidEmailToken"] = "RegisterInvalidEmailToken";
    ErrorCode["RegisterInvalidDetails"] = "RegisterInvalidDetails";
    ErrorCode["InviteInvalidUser"] = "InviteInvalidUser";
    ErrorCode["PermissionInvalid"] = "PermissionInvalid";
    ErrorCode["OwnerInvalid"] = "OwnerInvalid";
    ErrorCode["ErrorInvalidPlan"] = "ErrorInvalidPlan";
    ErrorCode["FactTeamNotInMatch"] = "FactTeamNotInMatch";
    ErrorCode["FactNotInBreak"] = "FactNotInBreak";
    ErrorCode["FactInBreak"] = "FactInBreak";
    ErrorCode["FactMissingData"] = "FactMissingData";
    ErrorCode["FactMissingPeriod"] = "FactMissingPeriod";
    ErrorCode["FactInvalidPeriod"] = "FactInvalidPeriod";
    ErrorCode["FactClockInBreak"] = "FactClockInBreak";
    ErrorCode["FactClockInPenaltyShootout"] = "FactClockInPenaltyShootout";
    ErrorCode["FactAdjustClockStopped"] = "FactAdjustClockStopped";
    ErrorCode["BatchFactUpdateNotSameMatch"] = "BatchFactUpdateNotSameMatch";
    ErrorCode["FactClockRunning"] = "FactClockRunning";
    ErrorCode["FactClockStopped"] = "FactClockStopped";
    ErrorCode["ErrorAttemptedClockDelete"] = "ErrorAttemptedClockDelete";
    ErrorCode["FactInPregame"] = "FactInPregame";
    ErrorCode["FactPeriodNotStarted"] = "FactPeriodNotStarted";
    ErrorCode["FactPeriodStarted"] = "FactPeriodStarted";
    ErrorCode["FactPeriodInFuture"] = "FactPeriodInFuture";
    ErrorCode["FactPeriodFinished"] = "FactPeriodFinished";
    ErrorCode["FactMissingTeam"] = "FactMissingTeam";
    ErrorCode["FactPeriodNotMostRecent"] = "FactPeriodNotMostRecent";
    ErrorCode["FileUpload"] = "FileUpload";
    ErrorCode["FileWrongType"] = "FileWrongType";
    ErrorCode["FileWrongDimensions"] = "FileWrongDimensions";
    ErrorCode["FileWrongSize"] = "FileWrongSize";
    ErrorCode["Base"] = "Base";
    ErrorCode["General"] = "General";
    ErrorCode["BadRequest"] = "BadRequest";
    ErrorCode["Unauthorized"] = "Unauthorized";
    ErrorCode["NotFound"] = "NotFound";
    ErrorCode["UserNotInOrg"] = "UserNotInOrg";
    ErrorCode["ResourceNotFound"] = "ResourceNotFound";
    ErrorCode["ResourceUnique"] = "ResourceUnique";
    ErrorCode["StripeNoSubscription"] = "StripeNoSubscription";
})(ErrorCode = exports.ErrorCode || (exports.ErrorCode = {}));
//# sourceMappingURL=codes.js.map